import type { AnimalDetail } from "../types";
import { isTerminalLifecycleState } from "./stageTransitions";

// Espejo de las preconditions del backend en validateEventPreconditions.
// Si el backend agrega/cambia reglas, actualizar acá. Los dialogs se abren
// solo cuando el predicate retorna true; el backend igual valida en el submit.

export function canRecordCalving(animal: AnimalDetail): boolean {
  return !animal.retiredAt && animal.lifecycleState === "cow_producing" && !animal.isLactating;
}

export function canRecordDryOff(animal: AnimalDetail): boolean {
  return !animal.retiredAt && animal.lifecycleState === "cow_producing" && animal.isLactating;
}

export function canTransitionStage(animal: AnimalDetail): boolean {
  return !animal.retiredAt && !isTerminalLifecycleState(animal.lifecycleState);
}

// Frontera contable NIIF Sec 34 §4.5: capitaliza el activo biológico a Vacas
// en producción y activa el cronograma de depreciación. Solo disponible para
// novillas que NO tengan firstCalvingAt previo y NO estén ya en cow_producing.
export function canRecordFirstCalving(animal: AnimalDetail): boolean {
  return (
    !animal.retiredAt &&
    animal.firstCalvingAt === null &&
    animal.lifecycleState !== "cow_producing" &&
    !isTerminalLifecycleState(animal.lifecycleState)
  );
}
